import React from "react";
import { useNavigate, useParams } from "react-router-dom";

const Childitem = ({ item, setAddchild, setModalbox }) => {
  const { school_id, class_id } = useParams();
  const Navigate = useNavigate();
  const EditChild = () => {
    setAddchild((prev) => ({
      ...prev,
      name: item?.child_name,
      mobile: item?.parent_no,
      parent_name: item?.parent_name,
      gender: item?.gender,
      child_id: item?.child_view_id,
      std: item?.child_standard_key,
      edit: true,
    }));
    setModalbox((prev) => ({ ...prev, addchild: true }));
  };

  const StartEvaluation = (chilid) => {
    Navigate(
      `/evaluation/${school_id}/${class_id}/individual/${btoa(chilid)}/1`
    );
  };
  return (
    <div className="max-w-[300px] px-3 pt-2 rounded-md bg-[white] shadow-lg border-2 border-[#0001] my-2 mx-200  max-[500px]:max-w-full relative">
      {/* CHILD DETAIL */}
      <div className="flex flex-wrap text-sm items-start justify-between mt-3">
        <div className="m-1">
          <p className="font-medium text-[#0007]">Child name</p>
          <p className="font-semibold">{item?.child_name}</p>
        </div>
        <div className="m-1">
          <p className="font-medium text-[#0007]">Gender</p>
          <p className="font-semibold">{item?.gender}</p>
        </div>
        <div className="m-1">
          <p className="font-medium text-[#0007]">Parent name</p>
          <p className="font-semibold">{item?.parent_name}</p>
        </div>
        <div className="m-1">
          <p className="font-medium text-[#0007]">Parent mobile</p>
          <p className="font-semibold">{item?.parent_no}</p>
        </div>
        <div className="m-1">
          <p className="font-medium text-[#0007]">Std</p>
          <p className="font-semibold">{item?.child_standard}</p>
        </div>
      </div>
      {/* CHILD BUTTON */}
      <div className="w-full flex items-center justify-center my-2">
        <button
          onClick={EditChild}
          className="mx-0 text-sm px-2 font-semibold py-1 rounded-md absolute top-0 right-0"
        >
          <i className="fa-solid fa-pen-to-square"></i>
        </button>

        <button
          onClick={() => StartEvaluation(item?.child_view_id)}
          className={`mx-2 border-2 border-[#f78800] text-[#f79221] font-semibold text-xs px-4 py-1 rounded-md ${
            item?.child_teacher_eval_completed == "Y"
              ? "opacity-30 pointer-events-none"
              : "opacity-100 pointer-events-auto"
          }`}
        >
          Start
        </button>
      </div>
    </div>
  );
};

export default Childitem;
